<template>
<div class="big-figure" :class="classObject">
    <div class="big-figure__body">
        <div class="big-figure__card">
            <slot></slot>
        </div>
        <div class="big-figure__image">
            <div
                v-if="image"
                class="big-figure__image-bg"
                :style="`background-image: url(${image});`"
            ></div>
            <div v-else class="big-figure__image-bg big-figure__image-bg--dummy"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'big-figure',
    props: {
        image: {
            type: String
        },
        positionX: {
            type: String,
            default: 'left',
            validator: (prop) => ['left', 'right'].includes(prop)
        },
        positionY: {
            type: String,
            default: 'top',
            validator: (prop) => ['top', 'bottom'].includes(prop)
        },
        theme: {
            type: String,
            validator: (prop) => ['news'].includes(prop)
        },
        size: {
            type: String,
            validator: (prop) => ['m', 's'].includes(prop),
            default: 'm'
        }
    },
    data () {
        return {}
    },
    computed: {
        classObject () {
            return {
                [`big-figure--position-${this.positionX}`]: this.positionX,
                [`big-figure--position-${this.positionY}`]: this.positionY,
                [`big-figure--theme-${this.theme}`]: this.theme
                // [`big-figure--size-${this.size}`]: this.size
            }
        }
    }
}
</script>

<style lang="scss">
.big-figure {
    $parent: &;

    &__body {
        position: relative;
        padding-bottom: $token-spacers-4-xl;

        @include breakpoint (v-tablet) {
            padding-bottom: 0;
        }
    }

    &__image-bg {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        position: absolute;
        top: 0;
        left: 0;
    }

    &__image {
        width: 56.5%; // для совпадения с сеткой
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: $token-colors-black-5;

        &:after {
            content: '';
            display: block;
            padding-top: 80%;
        }

        @include breakpoint (tablet) {
            width: 70%;
        }

        @include breakpoint (v-tablet) {
            width: 100%;
            height: auto;
            position: relative;
            background-color: #f2f2f6;
            margin: 0 !important;
        }

        @include breakpoint(v-tablet) {
            #{$parent}__caption {
                width: 100%;
                order: -1 !important;
                margin: 0;
            }

            #{$parent}__image {
                width: 100%;
                margin: 0;
            }

            #{$parent}__card {
                min-height: auto;
                padding: 16px;
            }
            margin: 0 !important;
        }
    }

    &__card {
        padding: $token-spacers-2-xl;
        position: relative;
        background-color: #f2f2f6;
        z-index: 2;
        width: 50%;
        min-width: 480px;
        box-shadow: 0 100px 80px rgba(55, 56, 58, 0.07),
            0 42px 33px rgba(55, 56, 58, 0.05),
            0 22px 18px rgba(55, 56, 58, 0.04),
            0 12px 10px rgba(55, 56, 58, 0.03),
            0 7px 5px rgba(55, 56, 58, 0.03),
            0 3px 2px rgba(55, 56, 58, 0.02);

        @include breakpoint (tablet) {
            padding: $token-spacers-s;
        }

        @include breakpoint (v-tablet) {
            padding: $token-spacers-s $token-spacers-2-xs;
            width: 100%;
            box-shadow: none;
            min-width: auto;
        }
    }

    &--position {
        &-top {
            #{$parent}__image  {
                margin-top: $token-spacers-2-xl;
                height: calc(100% - #{$token-spacers-2-xl});
            }
        }

        &-right {
            #{$parent}__card  {
                margin-left: auto;
            }

            #{$parent}__image  {
                left: 0;
                right: auto;
                margin-top: $token-spacers-2-xl;
                height: calc(100% - #{$token-spacers-2-xl});
            }
        }
    }

    &--theme-news {
        #{$parent}__card {
            padding: $token-spacers-l;
            width: 80%;
            padding-right: 25%;
            z-index: 1;
            box-shadow: none;

            @include breakpoint (tablet) {
                padding: $token-spacers-s;
                padding-right: 25%;
            }

            @media screen and (max-width: 700px) {
                padding-right: 0;
                width: 100%;
            }

            @include breakpoint (mobile) {
                padding: $token-spacers-s $token-spacers-2-xs;
            }
        }

        #{$parent}__image {
            width: 40%;
            height: auto;
            z-index: 2;
            background-color: transparent;
            box-shadow:
                0 22px 17px #37383a0b,
                0 12px 10px #37383a09,
                0 6px 5px #37383a07,
                0 2px 2px #37383a05;

            @include breakpoint (tablet) {
                margin-top: 40px !important;
            }

            @media screen and (max-width: 700px) {
                display: none;
            }

            &:after {
                display: none;
            }
        }

        #{$parent}__image-bg {
            padding-top: 95%;
            background-size: cover;
            background-position: 50% 50%;
            background-repeat: no-repeat;

            &--dummy {
                background-image: url('/images/news/union-blue.png');
                background-size: cover;
            }
        }
    }
}
</style>
